var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.103 1.481a1 1 0 0 1 1.794 0l4.258 8.63a1 1 0 0 0 .753.546l9.523 1.384a1 1 0 0 1 .554 1.706l-6.891 6.716a1 1 0 0 0-.288.885l1.627 9.484a1 1 0 0 1-1.45 1.054l-8.518-4.477a1 1 0 0 0-.93 0l-8.518 4.477a1 1 0 0 1-1.45-1.054l1.626-9.484a1 1 0 0 0-.287-.885l-6.892-6.716a1 1 0 0 1 .554-1.706l9.523-1.384a1 1 0 0 0 .753-.547l4.26-8.629Z",
    fill: "#343845"
  })));
};
export default SvgStar;